<template>
  <div class="bsp-setup">
    <div class="setup-card">
      <h2>Configure Your Partner</h2>

      <div class="form-group">
        <label for="agreeability">Agreeability Level</label>
        <div class="slider-container">
          <input
            type="range"
            id="agreeability"
            v-model="agreeability"
            min="0"
            max="100"
            class="slider"
          />
          <div class="slider-labels">
            <span>Resistant</span>
            <span>Agreeable</span>
          </div>
          <div class="slider-value">{{ agreeability }}</div>
        </div>
      </div>

      <div class="form-group">
        <label for="product-context">Product Context (Optional)</label>
        <textarea
          id="product-context"
          v-model="productContext"
          placeholder="Describe the product or service you're selling"
          rows="4"
        ></textarea>
      </div>

      <div class="actions">
        <b-button
          variant="primary"
          size="lg"
          @click="startCall"
          :disabled="isLoading"
        >
          {{ isLoading ? 'Starting...' : 'Start Call' }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BSPSetup",
  data () {
    return {
      agreeability: 50,
      productContext: "",
      isLoading: false
    }
  },
  methods: {
    startCall () {
      this.isLoading = true
      this.$emit("start-call", {
        agreeability: this.agreeability,
        productContext: this.productContext
      })
    }
  },
  created () {
    // Listen for the call-started event from parent
    this.$root.$on("call-started", () => {
      this.isLoading = false
    })
  },
  beforeDestroy () {
    // Clean up event listener
    this.$root.$off("call-started")
  }
}
</script>

<style lang="scss" scoped>
.bsp-setup {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  padding: 0.5rem;
  // background-color: #f8f9fa;
}

.setup-card {
  background-color: $white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  padding: 1.5rem;
  width: 100%;
  max-width: 600px;
  border: 1px solid rgba(0, 0, 0, 0.05);

  h2 {
    margin-bottom: 2rem;
    font-size: 1.75rem;
    font-weight: 600;
    color: $slate90;
    text-align: center;
  }
}

.form-group {
  margin-bottom: 2rem;

  label {
    display: block;
    margin-bottom: 1rem;
    font-weight: 500;
    color: $slate80;
    font-size: 1rem;
  }

  textarea {
    width: 100%;
    padding: 1rem;
    border: 2px solid $slate20 !important;
    border-radius: 8px;
    resize: vertical;
    color: $slate80;
    font-size: 1rem;
    min-height: 120px;
    background-color: #fff;
    transition: all 0.3s ease;

    &:focus {
      outline: none;
      border-color: $orange60 !important;
      box-shadow: 0 0 0 2px $orange20 !important;
    }

    &::placeholder {
      color: $slate40;
    }
  }
}

.slider-container {
  position: relative;
  padding: 1.5rem 0.5rem;
  margin: 0 -0.5rem;
}

.slider {
  width: 100%;
  height: 6px;
  -webkit-appearance: none;
  appearance: none;
  background: linear-gradient(to right, $slate20 0%, $slate20 100%);
  outline: none;
  border-radius: 3px;
  margin: 1rem 0;
  position: relative;
  top: 50%;
  transform: translateY(-50%);

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: $orange;
    cursor: pointer;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    position: relative;
    top: 50%;
    transform: translateY(-35%);

    &:hover {
      transform: translateY(-35%) scale(1.1);
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    }
  }

  &::-moz-range-thumb {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: $orange;
    cursor: pointer;
    border: 2px solid #fff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
    transition: all 0.2s ease;
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    &:hover {
      transform: translateY(-50%) scale(1.1);
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
    }
  }
}

.slider-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 0.75rem;
  font-size: 0.9rem;
  color: $slate60;
  font-weight: 500;
}

.slider-value {
  position: absolute;
  top: 0;
  right: 0.5rem;
  font-weight: 600;
  color: $orange;
  font-size: 1.1rem;
}

.actions {
  margin-top: 2.5rem;
  display: flex;
  justify-content: center;

  .btn-primary {
    padding: 0.75rem 2.5rem;
    font-size: 1.1rem;
    font-weight: 500;
    border-radius: 8px;
    background: $orange;
    border: none;
    box-shadow: 0 4px 12px rgba($orange, 0.2);
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba($orange, 0.25);
      background: darken($orange, 5%);
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 8px rgba($orange, 0.2);
    }

    &:disabled {
      background: $slate40;
      box-shadow: none;
      cursor: not-allowed;
    }
  }
}
</style>
